import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { AUTH_ROUTE_PREFIX } from '@app/enums';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-main',
  imports: [RouterLinkWithHref, NzIconModule],
  templateUrl: './main.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './main.component.scss',
})
export class MainComponent {
  loginPath = `${AUTH_ROUTE_PREFIX}/login`;
}
